'use strict';
function Controller() {
	this.toggleDropDown = () => {
		this.dropDownVisible = !this.dropDownVisible;
	};

	this.itemClick = item => {
		item.onClick();
		this.dropDownVisible = false;
	};
}
angular.module('PinMeTo.UI').component('pmtDropdownButton', {
	templateUrl: 'pmtShared/pmtUi/DropdownButton.html',
	controller: Controller,
	bindings: {
		items: '<',
		pmtBtnStyleLight: '<'
	},
	transclude: true
});
